var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st11{fill:#a1a3a8}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a1a3a8"
    },
    d: "M230.5 28.6h51v80.8h-51z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.3 221.8 302 188.7 382.9 88c7.1-8.8 19.9-10.2 28.7-3.1l9.4 7.6c8.8 7.1 10.2 19.9 3.1 28.7zm-174.6 0 41.2-33.1L129.1 88c-7.1-8.8-19.9-10.2-28.7-3.1L91 92.4c-8.8 7.1-10.2 19.9-3.1 28.7z",
    style: {
      fill: "#a1a3a8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 295.2,
    r: 212.3,
    style: {
      fill: "#a1a3a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 295.2c0-113 88.3-205.4 199.7-211.9-4.2-.2-8.4-.4-12.6-.4-117.2 0-212.3 95-212.3 212.3s95 212.3 212.3 212.3c4.2 0 8.4-.1 12.6-.4C157.3 500.5 69 408.2 69 295.2",
    style: {
      fill: "#a1a3a8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 295.2,
    r: 165.3,
    style: {
      fill: "#def6fc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 295.2c0-87 67.3-158.3 152.6-164.8-4.2-.3-8.4-.5-12.6-.5-91.3 0-165.3 74-165.3 165.3s74 165.3 165.3 165.3c4.2 0 8.5-.2 12.6-.5-85.4-6.5-152.6-77.8-152.6-164.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 52.6H206c-6.4 0-11.5-5.2-11.5-11.5v-25c0-6.4 5.2-11.5 11.5-11.5h100c6.4 0 11.5 5.2 11.5 11.5v25c0 6.4-5.1 11.5-11.5 11.5",
    style: {
      fill: "#a1a3a8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 4.6c-6.4 0-11.5 5.2-11.5 11.5v25c0 6.4 5.2 11.5 11.5 11.5h14v-48z",
    style: {
      fill: "#a1a3a8"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M176.4 265.6v-36.4c0-18.7 12.3-26 28.1-26s28.1 7.3 28.1 26v36.4c0 18.9-12.3 26-28.1 26s-28.1-7.1-28.1-26m46.6-36.5c0-11.8-6.9-17-18.4-17-11.3 0-18.2 5.2-18.2 17v36.4c0 11.8 6.9 17 18.2 17 11.6 0 18.4-5.2 18.4-17zm83.2-29.3c0 .9-.2 1.7-.7 2.6l-90.8 175.9c-.9 2.1-2.8 3.1-4.7 3.1-2.6 0-5-2.1-5-4.5 0-.9 0-1.7.5-2.6L297 196.8c.7-1.9 2.4-2.4 3.8-2.4 2.3 0 5.4 2.1 5.4 5.4m-29.6 150.9v-36.4c0-18.7 12.3-26 28.1-26s28.1 7.3 28.1 26v36.4c0 18.9-12.3 26-28.1 26s-28.1-7.1-28.1-26m46.6-36.4c0-11.8-6.9-17-18.4-17-11.3 0-18.2 5.2-18.2 17v36.4c0 11.8 6.9 17 18.2 17 11.6 0 18.4-5.2 18.4-17zM215.4 14.7c-2.5 0-4.6 2-4.6 4.6v16.4c0 2.5 2 4.6 4.6 4.6 2.5 0 4.6-2 4.6-4.6V19.2c0-2.5-2.1-4.5-4.6-4.5m27.1 0c-2.5 0-4.6 2-4.6 4.6v16.4c0 2.5 2 4.6 4.6 4.6s4.6-2 4.6-4.6V19.2c-.1-2.5-2.1-4.5-4.6-4.5m27 0c-2.5 0-4.6 2-4.6 4.6v16.4c0 2.5 2 4.6 4.6 4.6s4.6-2 4.6-4.6V19.2c0-2.5-2.1-4.5-4.6-4.5m27.1 0c-2.5 0-4.6 2-4.6 4.6v16.4c0 2.5 2 4.6 4.6 4.6s4.6-2 4.6-4.6V19.2c0-2.5-2.1-4.5-4.6-4.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m411.5 144.1 16.2-20.1c8.6-10.7 6.9-26.5-3.8-35.1l-9.4-7.6c-10.7-8.6-26.5-6.9-35.1 3.8l-16.9 21C339 92.8 313.1 84 286.1 80.3V57.2h20c8.9 0 16.1-7.2 16.1-16.1v-25C322.1 7.2 314.9 0 306 0H206c-8.9 0-16.1 7.2-16.1 16.1v25c0 8.9 7.2 16.1 16.1 16.1h20v23.2c-27.1 3.7-52.9 12.5-76.4 25.8l-16.9-21c-4.2-5.2-10.1-8.5-16.7-9.2s-13.1 1.2-18.3 5.3l-9.4 7.6c-10.7 8.6-12.4 24.4-3.8 35.1l16.2 20.1c-39.5 40.7-61.3 94.2-61.3 151.1 0 57.9 22.6 112.4 63.5 153.3 41 41 95.4 63.5 153.3 63.5s112.4-22.6 153.3-63.5c41-41 63.5-95.4 63.5-153.3-.2-56.9-21.9-110.4-61.5-151.1m-25-53.3c5.5-6.8 15.5-7.9 22.3-2.4l9.4 7.6c3.3 2.6 5.4 6.4 5.8 10.6.5 4.2-.7 8.3-3.4 11.6L405 137.7c-10.7-10.2-22.3-19.1-34.6-26.8zM206 48.1c-3.8 0-7-3.1-7-7v-25c0-3.8 3.1-7 7-7h100c3.8 0 7 3.1 7 7v25c0 3.8-3.1 7-7 7zm70.9 9.1v22.1c-6.9-.7-13.9-1-20.9-1s-14 .3-20.9 1V57.2zm-185.5 61c-2.7-3.3-3.9-7.4-3.4-11.6s2.5-8 5.8-10.6l9.4-7.6c3.3-2.6 7.4-3.9 11.6-3.4s8 2.5 10.6 5.8l16.1 20c-12.3 7.7-23.9 16.6-34.6 26.8zM256 502.9c-114.5 0-207.7-93.2-207.7-207.7S141.5 87.5 256 87.5s207.7 93.2 207.7 207.7S370.5 502.9 256 502.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M256 125.4c-93.6 0-169.8 76.2-169.8 169.8S162.4 465 256 465s169.8-76.2 169.8-169.8c0-93.7-76.2-169.8-169.8-169.8m0 330.5c-88.6 0-160.7-72.1-160.7-160.7S167.4 134.5 256 134.5s160.7 72.1 160.7 160.7S344.6 455.9 256 455.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.f2cecd13abc110351afc5f85d4400c01.svg";
export { ForwardRef as ReactComponent };